import type {UsbModemLocation} from "../../../api";
import type {Common_ControlBlockDto} from "../../../api";

export type SystemSettingsProps = {
  device: Common_ControlBlockDto & {
    warrantyExpirationDate?: string | null;
    daysUntilEndOfWarranty?: number;
    nextMaintenanceDate?: string | null;
    daysUntilMaintenance?: number;
  };
  getDeviceData: any;
  isAdmin: boolean;
  executeCommand: any;
}

export type UsbModemProps = {
  loading: boolean;
  deviceId: string;
}

export const USB_MODEM_LOCATION_LABELS: Record<UsbModemLocation, string> = {
  NoModem: 'Модем не управляется',
  OnCsRelay1: 'Модем на реле 1 станции',
  OnCsRelay2: 'Модем на реле 2 станции',
  OnUsbPort: 'Модем на управляемом usb порту',
};
